import React from "react";
import {Checkbox, Chip} from "@material-ui/core";
import useStyles from "../../styles";

import MUIDataTable from "mui-datatables";
import jobninja from "../../../../images/jn.svg";
import {useHistory} from "react-router-dom";
import moment from "moment";
import 'moment/locale/de';
import {BASE_URL} from "../../../../datamanagement/network";

const states = {
    false: "success",
    true: "secondary",
};

export default function TableComponent({data}) {
    const classes = useStyles();
    const history = useHistory();


    const columns = [
        {
            name: "title",
            label: "Stellentitel",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "company",
            label: "Firma",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "location",
            label: "Ort",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "id_in_source",
            label: "Posting Id",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "created_at",
            label: "Schaltungs\u00ADdatum",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    moment.locale('de');
                    return moment(data[dataIndex].created_at).format('L')
                }
            },
        },
        {
            name: "impressions",
            label: "Seiten\u00ADaufrufe",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "clickouts",
            label: "Bewerbungs\u00ADaktionen",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "applications",
            label: "Bewerber",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    if (data[dataIndex].application_type === 'email') {
                        return data[dataIndex].likes
                    } else {
                        return '-'
                    }

                }
            },
        },
        {
            name: "finished",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    const finished = data[dataIndex].finished;
                    const classname = states[finished]
                    return (
                        <Chip label={finished ? "Offline" : "Online"} classes={{root: classes[classname]}}/>
                    );
                },
            },
        },
        {
            name: "id",
            label: "Link",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    const id = data[dataIndex].id;
                    const finished = data[dataIndex].finished;
                    return (
                        !finished ?
                            <a target="_blank" rel="noopener noreferrer" href={`${BASE_URL}/jobs/${id}`}><img alt="Logo" src={jobninja}/></a> : null
                    );
                },
            },
        },
    ];

    return (<MUIDataTable
        data={data}
        columns={columns}
        components={{Checkbox: (props) => <Checkbox  {...props} color={"secondary"}/>}}
        options={{
            selectableRowsHideCheckboxes: true, print: false, textLabels: {
                body: {
                    noMatch: "Entschuldigung, keine übereinstimmenden Datensätze gefunden",
                    toolTip: "Sortieren",
                    columnHeaderTooltip: column => `Nach ${column.label} sortieren`,
                },
                pagination: {
                    next: "Nächste Seite",
                    previous: "Vorherige Seite",
                    rowsPerPage: "Einträgen pro Seite:",
                    displayRows: "von",
                },
                toolbar: {
                    search: "Suche",
                    downloadCsv: "CSV Herunterladen",
                    print: "Drucken",
                    viewColumns: "Siehe Spalten",
                    filterTable: "Filtertabelle",
                },
                filter: {
                    all: "Alle",
                    title: "FILTER",
                    reset: "ZURÜCKSETZEN",
                },
                viewColumns: {
                    title: "Spalten anzeigen",
                    titleAria: "Tabellenspalten anzeigen",
                },
                selectedRows: {
                    text: "Einträge(n) ausgewählt",
                    delete: "Löschen",
                    deleteAria: "Ausgewählte Einträgen löschen",
                },
            },
            onCellClick: (rowData, {colIndex, dataIndex}) => {
                if (colIndex !== 8) {
                    history.push(`/app/job/${data[dataIndex].id}`);
                }
            }
        }}
    />);
}



